import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

function usePageViews() {
  let location = useLocation();
  const firstName = useSelector((state) => state.user?.profile?.firstName);
  const userName = useSelector((state) => state.user?.profile?.userName);
  const lastName = useSelector((state) => state.user?.profile?.lastName);
  const email = useSelector((state) => state.user?.profile?.email);
  const accessToken = useSelector((state) => state.user?.accessToken);
  const gamePlayerId = useSelector((state) => state.user?.profile?._id);

  useEffect(() => {
    try {
      if (!gamePlayerId || !accessToken) {
        window?.mt("send", "pageview", {
          page_url: window.location.href,
        });
      } else {
        window?.mt("send", "pageview", {
          email: email,
          firstname: firstName,
          lastname: lastName,
          username: userName,
          page_url: window.location.href,
        });
      }
    } catch (error) {
      console.log("Mautic initialization failed", error);
    }
  }, [
    location,
    gamePlayerId,
    accessToken,
    firstName,
    lastName,
    email,
    userName,
  ]);
}

function ActivityRouteListener() {
  usePageViews();
  return null;
}

export default ActivityRouteListener;
